import {Link} from '~library/atoms/Link';
import {Typography} from '~library/atoms/Typography';

type PhoneWarningProps = {
  preText: string;
  className?: string;
};

export const PhoneWarning = ({preText, className}: PhoneWarningProps) => (
  <Typography variant="paragraph4" color="pebble" className={className}>
    {preText} you agree to our{' '}
    <Link
      href="/content/terms"
      title="terms of service"
      target="_blank"
      data-qa-id="link-terms"
      thickness="thin"
      className="RSVP-modal__terms-and-privacy"
    >
      terms
    </Link>{' '}
    &{' '}
    <Link
      href="/content/privacy_policy"
      title="privacy policy"
      target="_blank"
      data-qa-id="link-privacy"
      thickness="thin"
      className="RSVP-modal__terms-and-privacy"
    >
      privacy policy
    </Link>{' '}
    & you consent to receive recurring event updates via text message from evite & event hosts.
    Message & data rates may apply. Message quantity & frequency may vary. Reply HELP for help, STOP
    to cancel.
  </Typography>
);
